import React, { useEffect, useState, useRef } from 'react';
import { Volume2Icon, VolumeXIcon } from 'lucide-react';
export function BackgroundAudio() {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  // El video que pasaste se usará como fuente de audio
  const audioUrl = 'https://cdn.magicpatterns.com/uploads/htb8hH83LNJ8Fms76gHC5d/YTDown.com_Shorts_Cancion-para-Dormir-Bebes-con-Ruido-Blan_Media_MiVBtLETXQ0_001_1080p%20(1).mp4';
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    // Configurar volumen suave para no asustar
    audio.volume = 0.3;
    // Intentar reproducir automáticamente
    const playAttempt = setInterval(() => {
      if (!isPlaying && !hasInteracted) {
        audio.play().then(() => {
          setIsPlaying(true);
          clearInterval(playAttempt);
        }).catch(() => {
          // El navegador bloqueó el autoplay, es normal
          // Esperaremos a que el usuario interactúe
        });
      }
    }, 3000);
    // Escuchar la primera interacción del usuario en la página
    const handleInteraction = () => {
      if (!hasInteracted) {
        setHasInteracted(true);
        audio.play().then(() => setIsPlaying(true)).catch(console.error);
        // Remover los listeners una vez que interactuó
        document.removeEventListener('click', handleInteraction);
        document.removeEventListener('scroll', handleInteraction);
        document.removeEventListener('touchstart', handleInteraction);
      }
    };
    document.addEventListener('click', handleInteraction);
    document.addEventListener('scroll', handleInteraction, {
      once: true
    });
    document.addEventListener('touchstart', handleInteraction, {
      once: true
    });
    return () => {
      clearInterval(playAttempt);
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('scroll', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
    };
  }, [isPlaying, hasInteracted]);
  const toggleAudio = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      audio.play().then(() => setIsPlaying(true)).catch(console.error);
    }
    setHasInteracted(true);
  };
  return <>
      <audio ref={audioRef} src={audioUrl} loop preload="auto" data-id="element-313" />

      <button onClick={toggleAudio} className="fixed top-4 right-4 md:top-6 md:right-6 z-50 w-10 h-10 md:w-12 md:h-12 bg-navy-card/80 backdrop-blur-md border border-gold/30 rounded-full flex items-center justify-center text-gold shadow-lg hover:bg-navy-light transition-all duration-300 hover:scale-105" aria-label={isPlaying ? 'Pausar música relajante' : 'Reproducir música relajante'} data-id="element-314">
        {isPlaying ? <Volume2Icon className="w-5 h-5 md:w-6 md:h-6 animate-pulse" data-id="element-315" /> : <VolumeXIcon className="w-5 h-5 md:w-6 md:h-6 opacity-70" data-id="element-316" />}
      </button>
    </>;
}